<lib-dialog>
  <div class="importar-dependencia-dialog">
    <!-- Header -->
    <div class="dialog-header">
      <h3 class="dialog-title">
        {{ 'ACTION.IMPORT' | translate }}
      </h3>

      <button
        type="button"
        class="close-btn"
        (click)="cancelar()"
        [disabled]="importando()"
        [attr.aria-label]="'ACTIONS.CLOSE' | translate"
      >
        ✕
      </button>
    </div>

    <!-- Steps -->
    <div class="steps-indicator">
      <div
        class="step"
        [class.active]="!importacionCompletada()"
        [class.completed]="importacionCompletada()"
      >
        <div class="step-number">1</div>
        <div class="step-label">
          {{ 'IMPORT.STEP.UPLOAD' | translate }}
        </div>
      </div>
      <div class="step-line" [class.active]="importacionCompletada()"></div>

      <div class="step" [class.active]="importacionCompletada()">
        <div class="step-number">2</div>
        <div class="step-label">
          {{ 'IMPORT.STEP.RESULT' | translate }}
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <!-- STEP 1: Upload -->
      @if (!importacionCompletada()) {
        <div class="step-content">
          <div class="upload-section">
            <h4 class="section-title">
              {{ 'IMPORT.SECTION.SELECT_FILE' | translate }}
            </h4>

            @if (plantillaUrl) {
              <lib-button
                variant="text"
                prefixIcon="Download"
                class="plantilla"
                (clicked)="descargarPlantilla()"
              >
                {{ 'IMPORT.TEMPLATE.DOWNLOAD' | translate }}
              </lib-button>
            }

            <lib-file-upload
              [accept]="'.csv,.xlsx'"
              [maxSize]="5242880"
              [multiple]="false"
              [label]="'IMPORT.FILEUPLOAD.LABEL' | translate"
              [buttonLabel]="'COMMON.IMPORT.BUTTON_LABEL' | translate"
              [dragLabel]="'COMMON.IMPORT.DRAG_LABEL' | translate"
              [hint]="'IMPORT.FILEUPLOAD.HINT' | translate"
              (filesSelected)="onFilesSelected($event)"
            >
            </lib-file-upload>

            @if (archivoSeleccionado()) {
              <div class="file-info-card">
                <div class="file-info-header">
                  <div class="file-icon-wrapper">
                    <lib-icon name="FileText"></lib-icon>
                  </div>

                  <div class="file-info-details">
                    <h4>
                      {{ archivoSeleccionado()?.name }}
                    </h4>

                    <p>{{ archivoSeleccionado()?.size || 0 | number }} bytes</p>
                  </div>
                </div>

                <div class="file-info-actions">
                  <lib-button variant="secondary" prefixIcon="Trash2" (clicked)="limpiarArchivo()">
                    {{ 'ACTIONS.DELETE' | translate }}
                  </lib-button>
                  <lib-button
                    variant="primary"
                    prefixIcon="Upload"
                    [loading]="importando()"
                    [disabled]="!puedeImportar()"
                    (clicked)="importarArchivo()"
                  >
                    {{
                      importando()
                        ? ('IMPORT.STATUS.IMPORTING' | translate)
                        : ('IMPORT.BUTTON.IMPORT' | translate)
                    }}
                  </lib-button>
                </div>
              </div>
            }

            @if (importando()) {
              <div class="loading-indicator">
                <div class="loading-spinner"></div>
                <span>
                  {{ 'IMPORT.STATUS.PROCESSING' | translate }}
                </span>
              </div>
            }
          </div>
        </div>
      }

      <br />
      @if (mostrarAlerta()) {
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      }

      <!-- STEP 2: Result -->
      @if (importacionCompletada() && summary()) {
        <div class="step-content">
          <div class="result-section">
            <!-- Summary -->
            <div class="summary-cards">
              <div class="summary-card total">
                <span class="card-value">
                  {{ summary()!.total }}
                </span>

                <span class="card-label">
                  {{ 'IMPORT.SUMMARY.TOTAL' | translate }}
                </span>
              </div>

              <div class="summary-card created">
                <span class="card-value">
                  {{ summary()!.created }}
                </span>

                <span class="card-label">
                  {{ 'IMPORT.SUMMARY.CREATED' | translate }}
                </span>
              </div>

              <div class="summary-card updated">
                <span class="card-value">
                  {{ summary()!.updated }}
                </span>

                <span class="card-label">
                  {{ 'IMPORT.SUMMARY.UPDATED' | translate }}
                </span>
              </div>

              <div class="summary-card skipped">
                <span class="card-value">
                  {{ summary()!.skipped }}
                </span>

                <span class="card-label">
                  {{ 'IMPORT.SUMMARY.SKIPPED' | translate }}
                </span>
              </div>
              <div class="summary-card invalid" [class.has-errors]="summary()!.invalid > 0">
                <span class="card-value">
                  {{ summary()!.invalid }}
                </span>

                <span class="card-label">
                  {{ 'IMPORT.SUMMARY.INVALID' | translate }}
                </span>
              </div>

              @if (
                summary()!.failedValidations !== undefined && summary()!.failedValidations !== null
              ) {
                <div
                  class="summary-card failed-validations"
                  [class.has-errors]="summary()!.failedValidations! > 0"
                >
                  <span class="card-value">
                    {{ summary()!.failedValidations }}
                  </span>

                  <span class="card-label">
                    {{ 'IMPORT.SUMMARY.FAILED_VALIDATIONS' | translate }}
                  </span>
                </div>
              }
            </div>

            <!-- Errors -->
            @if (hayErrores()) {
              <div class="errors-section">
                <div class="errors-header">
                  <h5>
                    {{ 'IMPORT.ERRORS.TITLE' | translate }}
                  </h5>
                </div>

                <div class="errors-table-wrapper">
                  <table class="errors-table">
                    <thead>
                      <tr>
                        <th class="col-line">
                          {{ 'IMPORT.TABLE.HEADER.LINE' | translate }}
                        </th>

                        <th class="col-field">
                          {{ 'IMPORT.TABLE.HEADER.FIELD' | translate }}
                        </th>

                        <th class="col-message">
                          {{ 'IMPORT.TABLE.HEADER.MESSAGE' | translate }}
                        </th>

                        <th class="col-value">
                          {{ 'IMPORT.TABLE.HEADER.RECEIVED_VALUE' | translate }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      @for (error of errors(); track error.line + error.field + $index) {
                        <tr [class]="getErrorClass(error.rule)">
                          <td>
                            {{ error.line || '-' }}
                          </td>

                          <td>
                            {{ error.field || '-' }}
                          </td>

                          <td>
                            <span class="error-message {{ getErrorClass(error.rule) }}">
                              {{ getErrorMessage(error) }}
                            </span>
                          </td>
                          <td>
                            {{ error.receivedValue ?? ('IMPORT.TABLE.EMPTY_FIELD' | translate) }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <!-- Result actions -->
            <div class="result-actions">
              @if (hayErrores()) {
                <lib-button
                  variant="secondary"
                  prefixIcon="FileDown"
                  (clicked)="descargarReporteErrores()"
                >
                  {{ 'IMPORT.BUTTON.DOWNLOAD_REPORT' | translate }}
                </lib-button>
              }
              <lib-button variant="primary" (clicked)="cerrarDialogo()">
                {{
                  hayErrores()
                    ? ('ACCOUNTING.COMMON.ACCEPT' | translate)
                    : ('ACTIONS.FINALIZE' | translate)
                }}
              </lib-button>
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Footer -->
    @if (!importacionCompletada()) {
      <div class="dialog-footer">
        <div class="actions">
          <lib-button variant="secondary" [disabled]="importando()" (clicked)="cancelar()">
            {{ 'ACCOUNTING.COMMON.CANCEL' | translate }}
          </lib-button>
        </div>
      </div>
    }
  </div>
</lib-dialog>
